"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const header_section_1 = __importDefault(require("./header.section"));
const header_style_1 = __importDefault(require("./header.style"));
const logo_mark_1 = __importDefault(require("../logo/logo.mark"));
const logo_text_1 = __importDefault(require("../logo/logo.text"));
class Header extends react_1.Component {
    constructor() {
        super(...arguments);
        this.renderLogo = () => {
            const { classes, onHomeClick, fullLogo } = this.props;
            return onHomeClick ? (jsx_runtime_1.jsxs("button", Object.assign({ type: "button", "data-cy": "go-home", className: classes.home, onClick: onHomeClick }, { children: [jsx_runtime_1.jsx(logo_mark_1.default, { axis: "y" }, void 0),
                    fullLogo && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.logoText }, { children: jsx_runtime_1.jsx(logo_text_1.default, { axis: "y", size: 16 }, void 0) }), void 0))] }), void 0)) : null;
        };
        this.render = () => {
            const { classes, children, fixed, loading, subheaderPrimary, subheaderSecondary } = this.props;
            const hasSubheader = !!subheaderPrimary || !!subheaderSecondary;
            return (jsx_runtime_1.jsx("div", Object.assign({ className: classes.root, "data-cy": "atomic-header" }, { children: jsx_runtime_1.jsxs("div", Object.assign({ className: fixed ? classes.fixed : null }, { children: [jsx_runtime_1.jsxs("div", Object.assign({ className: classes.header, "data-has-subheader": hasSubheader }, { children: [this.renderLogo(), jsx_runtime_1.jsx("div", Object.assign({ className: classes.sections, "aria-busy": loading }, { children: children }), void 0)] }), void 0),
                        hasSubheader && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.subheader, "data-cy": "atomic-subheader" }, { children: jsx_runtime_1.jsxs("div", Object.assign({ className: classes.sections, "aria-busy": loading }, { children: [subheaderPrimary && (jsx_runtime_1.jsx(header_section_1.default, Object.assign({ level: "primary" }, { children: subheaderPrimary }), void 0)),
                                    subheaderSecondary && (jsx_runtime_1.jsx(header_section_1.default, Object.assign({ level: "secondary" }, { children: subheaderSecondary }), void 0))] }), void 0) }), void 0))] }), void 0) }), void 0));
        };
    }
}
exports.Header = Header;
Header.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node,
    onHomeClick: prop_types_1.default.func,
    fixed: prop_types_1.default.bool,
    fullLogo: prop_types_1.default.bool,
    loading: prop_types_1.default.bool,
    subheaderPrimary: prop_types_1.default.node,
    subheaderSecondary: prop_types_1.default.node
};
Header.defaultProps = {
    fixed: true,
    onHomeClick: null,
    fullLogo: false,
    children: null,
    loading: false,
    subheaderPrimary: null,
    subheaderSecondary: null
};
exports.default = react_jss_1.default(header_style_1.default)(Header);
//# sourceMappingURL=header.js.map